import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { FIELD_PRIMITIVE__base } from '../../_primitives/_base/FIELD_PRIMITIVE__base';
import { FIELD__base } from '../FIELD__base';

export function FN_FIELD__get_fields_primitive_map(target: FIELD__base, with_children: boolean): MAP__serializable<string, FIELD_PRIMITIVE__base> {
  let out = new MAP__serializable<string, FIELD_PRIMITIVE__base>();

  if (target instanceof FIELD_PRIMITIVE__base) out.set(target.meta.field_id, target);

  if (target.is_stub()) return out; //we dont add children fields of stubs
  if (!with_children) return out;

  for (let field of Object.values(target)) {
    if (!(field instanceof FIELD__base)) continue;

    out.merge_with(FN_FIELD__get_fields_primitive_map(field, true));
  }

  return out;
}
